import { alertController, isPlatform } from '@ionic/vue';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';

export function usePermissionAlert(serviceName: string) {
  async function showAlert() {
    const a = await alertController.create({
      header: `${serviceName} Not Available`,
      message: `Some features of the NCSS app will not be available without access to ${serviceName}. Please go to your device\'s system settings and Grant Access.`,
      buttons: isPlatform('hybrid')
        ? [
            {
              role: 'cancel',
              text: 'Cancel',
            },
            {
              role: 'settings',
              text: 'Open Settings',
              handler: () =>
                NativeSettings.open({ optionAndroid: AndroidSettings.ApplicationDetails, optionIOS: IOSSettings.App }),
            },
          ]
        : [
            {
              text: 'Okay',
            },
          ],
    });
    await a.present();
  }

  return { showAlert };
}
